import { watch } from "vue";
import { i18n } from "@/i18n";

// Заголовок вкладки (NANFin-XXX).
//
// Раньше в <title> подставлялось `nan-report-admin-frontend` — Vue CLI берёт
// package.json:name, если title не задан явно. То есть заголовок был не текстом, а
// побочным эффектом имени npm-пакета: переименовали пакет — молча поехал заголовок.
// Использовать это имя как ключ перевода тем более нельзя — ключ оказался бы завязан
// на служебное имя, которое к UI отношения не имеет.
//
// Теперь источник правды — обычный i18n-ключ `t-app.title` (lang/<locale>/common.json):
// ru → «NAN Финансы», en → «NAN Finance».
//
// Заголовок пересчитывается при СМЕНЕ ЛОКАЛИ: переключатель языка в NavBar меняет
// i18n.locale (это ref) и пишет выбор в localStorage["app-locale"], а стартовая локаль
// восстанавливается в src/i18n.js. Без watch заголовок остался бы на языке, который был
// при загрузке страницы.
//
// Статический <title> для первой отрисовки (до старта JS) задаётся в vue.config.js —
// там он на дефолтной локали (ru); дальше его перебивает этот модуль.

/** Ставит заголовок вкладки по текущей локали. */
export function applyDocumentTitle() {
  document.title = i18n.t("t-app.title");
}

/**
 * Ставит заголовок сейчас и держит его в синхроне с локалью.
 * Зовётся один раз при старте приложения (main.js).
 *
 * Если позже понадобятся заголовки на страницу («Расходы — NAN Финансы»), расширять
 * надо здесь: взять routes.meta.title (он уже объявлен у части роутов, но пока нигде
 * не читается) и склеивать с t-app.title в router.afterEach.
 */
export function setupDocumentTitle() {
  applyDocumentTitle();
  watch(() => i18n.locale.value, applyDocumentTitle);
}
